import * as React from 'react';

import { Button, getKeyboardEventCode, IStyleConfig, mergeStyles, TextField } from '@cian/components';

const style = require('./index.css');

export interface ITagsInputProps {
  onTagInput(tagName: string): void;
  isModerator: boolean;
  containerStyle?: IStyleConfig;
  placeholder?: string;
}

interface ITagsInputState {
  value: string;
}

export class TagsInput extends React.Component<ITagsInputProps, ITagsInputState> {
  private tagsInput: TextField | null = null;

  public constructor(props: ITagsInputProps) {
    super(props);
    this.state = { value: '' };
  }

  public render() {
    const maxLength = this.props.isModerator ? 250 : 30;

    return (
      <div {...mergeStyles(style['container'], this.props.containerStyle)}>
        <TextField
          ref={input => {
            this.tagsInput = input;
          }}
          placeholder={this.props.placeholder || 'Укажите любое слово'}
          value={this.state.value}
          onValueChange={this.handleValueChange}
          onKeyDown={this.onKeyDown}
          containerStyle={style['inputContainer']}
          inputStyle={style['input']}
          maxLength={maxLength}
        />

        <Button onClick={this.onButtonClick} onKeyDown={this.onKeyDown} buttonStyle={style['button']} />
      </div>
    );
  }

  private handleTagInput = () => {
    if (this.state.value.length) {
      this.props.onTagInput(this.state.value);
      this.setState({ value: '' });
    }
  };

  private onKeyDown = (event: React.KeyboardEvent<EventTarget>) => {
    const nativeEvent = event.nativeEvent as KeyboardEvent;
    const code = getKeyboardEventCode(nativeEvent);

    if (code === 'Enter') {
      this.handleTagInput();
    }
  };

  private onButtonClick = () => {
    this.handleTagInput();
    this.focusInput();
  };

  private focusInput = () => {
    if (this.tagsInput) {
      this.tagsInput.focus();
    }
  };

  private handleValueChange = (value: string) => {
    this.setState({ value });
  };
}
